<template>
    <div class="add-qwilr-substitution-mapping">
      <h3>Add Substitution Mapping</h3>
      <div class="row">
        <div class="col-md-6">
            <div class="form-group mb-4">
                <label for="field" class="form-label">Field</label>
                <select 
                    style="height: 37px;padding-top: 0; padding-bottom: 0;"
                    class="form-select shadow-none fw-semibold rounded-0"
                    v-model="selectedQwilrDefinitionFieldId"
                    >
                    <option disabled value="">Select a field</option>
                    <option 
                        v-for="(field, index) in qwilrDefinitionFields" 
                        :key="index" 
                        :value="field.id"
                    >
                    {{ field.field }}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-4">
                <label for="qwilr-field" class="form-label">Qwilr Field</label>
                <input
                type="text"
                placeholder="Qwilr Field"
                id="qwilr-field"
                class="form-control"
                v-model="qwilrField"
                />
            </div>
        </div>
      </div>
      
      
      <div class="form-buttons">
        <div class="row">
            <div class="col-md-12">
                <button class="btn btn-primary" @click="addMaping" :disabled="isBusy">
                  <div v-if="isBusy">
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

                      Loading...
                  </div>
                  <div v-else>
                    Add Mapping
                  </div>
                </button>
                <button class="btn btn-secondary" @click="$emit('close')" style="margin-left: 5px;">Cancel</button>
            </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { GetQwilrDefinitionFields, AddQwilrSubstitutionMapping } from '@/core/services/entities/qwilr.service'
  import { useToast } from 'vue-toastification'

  export default{
    name:"AddQwilrSubstitutionMapping",
    props:{
        qwilrDefinitionId:{
            type:String,
            required:true
        },
        qwilrDefinitionElementId:{
            type:String,
            required:true
        }
    },
    data(){
        return{
            qwilrDefinitionFields:[],
            selectedQwilrDefinitionFieldId:null,
            qwilrField:'',
            isBusy:false
        }
    },
    methods:{
        async fetchQwilrDefinitionFields() {
            let data = await GetQwilrDefinitionFields(this.qwilrDefinitionId,false);
            if(data)
            {
              this.qwilrDefinitionFields = data.qwilrDefinitionFields;
            }

        },
        validateFields() {
          const toast = useToast();

          if (!this.qwilrField || this.qwilrField.trim() === '') {
            toast.error('Field is required!', { timeout: 3000 });
            return false; 
          }

          if (!this.selectedQwilrDefinitionFieldId) {
            toast.error('Definition Field is required!', { timeout: 3000 });
            return false; 
          }

          return true; 
        },
        async addMaping(){
          this.isBusy = true;
          const toast = useToast();

          setTimeout(async () => {
            if (!this.validateFields()) {
              this.isBusy=false;
              return;
          }
          
          const payload = { qwilrField:this.qwilrField, qwilrDefinitionFieldId:this.selectedQwilrDefinitionFieldId, qwilrDefinitionElementId:this.qwilrDefinitionElementId};
      
          await AddQwilrSubstitutionMapping(payload)
                  .then(response => {
                  if (response.status === 200) {
                      toast.success('Mapping added successfully!', {
                      timeout: 3000
                      })
                      this.isBusy=false;
                      this.$emit('mappingAdded'); // Emit the event to notify the parent component
                      this.$emit('close'); // Close the lightbox after adding data stream
                  }
                  })
                  .catch(ex => {
                      this.isBusy=false;
                      const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                      console.log(ex);
                      toast.error(`Failed to add mapping : ${errorMessage}`, {timeout: 2000,});
                  })
          }, 500);

        }
        

    },
    created() {
        this.fetchQwilrDefinitionFields();
    }
  }
 </script>
  
  <style scoped>
  .add-qwilr-substitution-mapping {
    width: 900px; /* Double the size */
    height: 300px; /* Double the size */
    padding: 40px; /* Increase padding */
    background-color: #fff; /* Ensure background is white */
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .form-group {
    margin-bottom: 1rem;
  }
  
  .form-label {
    display: block;
    margin-bottom: 0.5rem;
  }
  
  .form-control {
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
  }
  
  .form-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
  }
  
  .btn {
    padding: 0.5rem 1rem;
  }
  
  .btn-secondary {
    background-color: #6c757d;
    color: #fff;
  }
  
  .btn-secondary:hover {
    background-color: #5a6268;
  }
  </style>
  